import { render, staticRenderFns } from "./link-table-column-radio.vue?vue&type=template&id=044f949d&scoped=true&"
import script from "./link-table-column-radio.vue?vue&type=script&lang=js&"
export * from "./link-table-column-radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044f949d",
  null
  
)

export default component.exports